import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import 'react-toastify/dist/ReactToastify.css';
// import "@fortawesome/fontawesome-free/css/all.min.css";


import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
